(() => {
  const loadYouTubeEmbed = (iframe) => {
    const source = iframe.dataset.wsYoutubeSrc;
    if (!source) return;

    iframe.src = source;
    iframe.removeAttribute('data-ws-youtube-src');
  };

  const enhanceArticleVideos = () => {
    const embeds = document.querySelectorAll('.ws-article__content iframe[data-ws-youtube-src]');
    if (!embeds.length) return;

    if (!('IntersectionObserver' in window)) {
      embeds.forEach(loadYouTubeEmbed);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadYouTubeEmbed(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '600px 0px' }
    );

    embeds.forEach((iframe) => observer.observe(iframe));
  };

  const enhanceArticleTables = () => {
    document.querySelectorAll('.ws-article__content table').forEach((table) => {
      if (table.closest('.ws-article-table-scroll')) return;

      const parent = table.parentElement;
      const parentContainsOnlyTable = parent && parent.children.length === 1;

      if (parentContainsOnlyTable && parent.tagName === 'DIV') {
        parent.classList.add('ws-article-table-scroll');
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'ws-article-table-scroll';
      table.before(wrapper);
      wrapper.append(table);
    });
  };

  enhanceArticleTables();
  enhanceArticleVideos();
  document.addEventListener('shopify:section:load', () => {
    enhanceArticleTables();
    enhanceArticleVideos();
  });
})();
